import http from "../utils/http"

/**
 * 获取推广员申请信息
 */
export function getFenxiaoApplyInfo(params) {
    return http({
        url: "/api/fenxiao/apply_info",
        data: params,
        forceLogin: true
    })
}

/**
 * 提交推广员申请
 * @param {Object} data 申请数据
 */
export function submitFenxiaoApply(data) {
    return http({
        url: "/api/fenxiao/apply",
        method: "post",
        data: data,
        forceLogin: true
    })
}

/**
 * 获取推广员详情信息
 */
export function getFenxiaoDetail(params) {
    return http({
        url: "/fenxiao/api/fenxiao/detail",
        data: params,
        forceLogin: true
    })
}

/**
 * 获取推广员统计数据
 */
export function getFenxiaoStats(params) {
    return http({
        url: "/api/fenxiao/stats",
        data: params,
        forceLogin: true
    })
}

/**
 * 获取佣金列表
 */
export function getCommissionList(params) {
    return http({
        url: "/api/fenxiao/commission_list",
        data: params,
        forceLogin: true
    })
}

/**
 * 获取团队数量
 */
export function getFenxiaoTeamNum(params) {
    return http({
        url: "/fenxiao/api/fenxiao/teamnum",
        data: params,
        forceLogin: true
    })
}

/**
 * 申请提现
 * @param {Object} data 提现数据
 */
export function applyWithdraw(data) {
    return http({
        url: "/api/fenxiao/withdraw",
        method: "post",
        data: data,
        forceLogin: true
    })
}

/**
 * 获取提现记录
 */
export function getWithdrawList(params) {
    return http({
        url: "/api/fenxiao/withdraw_list",
        data: params,
        forceLogin: true
    })
}

/**
 * 获取佣金账单记录
 */
export function getFenxiaoBillList(params) {
    return http({
        url: "/fenxiao/api/account/page",
        data: params,
        forceLogin: true
    })
}

/**
 * 获取推广链接
 */
export function getPromoteLink(params) {
    return http({
        url: "/api/fenxiao/promote_link",
        data: params,
        forceLogin: true
    })
}

/**
 * 获取推广二维码
 */
export function getPromoteQrcode(params) {
    return http({
        url: "/api/fenxiao/promote_qrcode",
        data: params,
        forceLogin: true
    })
}

/**
 * 获取分销协议
 */
export function getFenxiaoAgreement(params) {
    return http({
        url: "/fenxiao/api/config/agreement",
        method: "get",
        data: params
    })
}

/**
 * 获取分销配置
 */
export function getFenxiaoConfig(params) {
    return http({
        url: "/fenxiao/api/config/fenxiao",
        data: params
    })
}

/**
 * 获取分销基本配置
 */
export function getFenxiaoBasicsConfig(params) {
    return http({
        url: "/fenxiao/api/config/basics",
        data: params
    })
}

/**
 * 获取分销申请状态
 */
export function getFenxiaoApplyStatus(params) {
    return http({
        url: "/fenxiao/api/apply/status",
        data: params,
        forceLogin: true
    })
}

/**
 * 获取推荐人信息
 */
export function getSourceMemberInfo(params) {
    return http({
        url: "/fenxiao/api/fenxiao/sourceinfo",
        data: params,
        forceLogin: true
    })
}

/**
 * 申请成为分销员
 */
export function applyFenxiao(data) {
    return http({
        url: "/fenxiao/api/apply/applyfenxiao",
        method: "post",
        data: data,
        forceLogin: true
    })
}